<div class="container mt-4 mt-xl-5">
   <div class="row d-flex justify-content-center">
      <div class="col-xl-8 col-12 mt-xl-3 mb-md-3">
	      
	      <router-outlet></router-outlet>

      </div>
   </div>
</div>
<footer>
  <p class="text-center">
	  <small><a href="https://www.methodem.nl"><img src="./assets/logo_methode-m.png" alt="Methode voor maatschappijleer" class="m-1" style="height:50px;" /></a>
		  <br />Naar een idee van <a href="https://www.methodem.nl">Methode M</a>, gemaakt door <a href="https://adaptivity.nl">Adaptivity</a>.</small>
  </p>
</footer>	      